import { Api } from './Api'

class Customer {
  getPromise (id) {
    return fetch(`${Api.getBaseUrl()}customer/${id}`, Api.getOptions('GET', {}))
  }
}

export default Customer
